// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { CustomerConfig } from "utils/ConfigTypes";

export const ExpertReadConfig: CustomerConfig = {
  id: "expertread",
  name: "Expert Read",
  pathPrefix: "expertread",
  allowGuestRuns: false,
  landingPage: "EXPERTREAD",
  customThemeOverride: {},
  headerConfig: {
    headerLogo: {
      label: "Expert Read",
      position: "center",
      route: "EXPERTREAD",
    },
  },
  loginHeader: "Log in to interpret RDT photos",
  loginDescription: "",
  showProgressBar: false,
};

export default ExpertReadConfig;
